import type { LoginAdministratorRequest } from "../../../../api/client/types/auth.types";
import { AdminLoginForm } from "../../components/AdminLoginForm/AdminLoginForm";
import { useLoginAdministrator } from "../../services/authService";


export const AdminLoginPage: React.FC = () => {
  const { mutate: loginAdministrator, isPending: isSubmitting } =
    useLoginAdministrator();
  const onLogin = (data: LoginAdministratorRequest) => {
    loginAdministrator(data);
  };
  return (
    <div className="flex items-center justify-center">
      <AdminLoginForm onLogin={onLogin} isSubmitting={isSubmitting} />
    </div>
  );
};
